import LocalPrintshopIcon from '@material-ui/icons/LocalPrintshop';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionSummary,
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ProgressBar from 'src/components/common/ProgressBar';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useTab } from 'src/components/hooks/useTab';
import { useUser } from 'src/components/hooks/useUser';
import { AppState } from 'src/store';
import { setMessage } from 'src/store/Message';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { setConfirmExitPopupVal } from 'src/store/confirmPopupVal';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { IIMVChecklistDetails } from 'src/types/IMVCheklist';
import InfomredConsentProcess from './InfomredConsentProces';
import MonitioringRequirments from './MonitioringRequirments';
import ProtocolDeviations from './ProtocolDeviations';
import SeriousAdverseEvents from './SeriousAdverseEvents';
import { useIMVCheckListPage } from './UseIMVChecklistPage';
import staticData from '../../../resources/static.json';
import { PopupComponent } from 'src/components/common/PopupComponent';
import printPdfWithViewer from 'src/components/common/PrintPdfWithViewer';
import { UI_TIME_ZONE } from 'src/constants/formats';
import { useGetimvChecklistDataQuery } from 'src/services/IMVCheckList';
import { useFieldTranslation } from '../../fields/useFieldTranslation';
import { useLazyGetimvReportDataQuery } from 'src/services/IMVReport';
import { hideLoader, showLoader } from 'src/store/Loader';
import { QulificationFileData } from 'src/types/SQReport';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useIMVReportPage } from '../IMVReport/UseIMVReportPage';
import BiologicalSampling from './BiologicalSampling';
import Discussion from './Discussion';
import ECIRB from './ECIRB';
import InvestigationalMedicine from './InvestigationalMedicine';
import Lab from './Lab';
import Site from './Site';
import Supplies from './Supplies';
import { setShowIMVchecklistCMPArr } from 'src/store/imvChecklist';
import { DynamicIcon } from '@pihealth/common-ui-library';
import { archLevel } from 'src/data/config';

const IMVChecklistPage: React.FunctionComponent<any> = () => {
  const { setTabVal, tabVal, tabsData } = useTab();
  const selectedRowData: any = useAppSelector(state => state.imvChecklist.selectedRowData);
  const currentTabinfo: any = tabsData.filter((item: any) => item.index === tabVal);
  const [expanded, setExpanded] = React.useState(true);
  const [expanded2, setExpanded2] = React.useState(false);
  const [expanded3, setExpanded3] = React.useState(false);
  const [expanded4, setExpanded4] = React.useState(false);
  const [expanded5, setExpanded5] = React.useState(false);
  const [expanded6, setExpanded6] = React.useState(false);
  const [expanded7, setExpanded7] = React.useState(false);
  const [expanded8, setExpanded8] = React.useState(false);
  const [expanded9, setExpanded9] = React.useState(false);
  const [expanded10, setExpanded10] = React.useState(false);
  const [expanded11, setExpanded11] = React.useState(false);
  const isLoading = false;
  const { checkPermission } = usePermissionWrapper();
  const { unSavedWarning } = useFieldTranslation();
  const [isUpdate, setIsupdate] = useState(false);
  const confirmexitpopupval: any = useSelector((state: AppState) => state.confirmexitpopupval);
  const [confirmNewVersion, setConfirmNewVersion] = useState(false);
  const dispatch = useDispatch();
  const dispatchApp = useAppDispatch();
  const [imvChecklistPageData, setImvChecklistPageData] = useState<Partial<IIMVChecklistDetails>>({});
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const [isAutoCopy, setIsAutoCopy] = useState(false);
  const { user } = useUser();
  const { getPreferredDateTimeInLocal } = usePreferedDateFormat();
  const isDisable = checkPermission('update_imvchecklist');
  const [copiedPublishedData, setCopiedPublishedData] = useState(false);
  const [isPrintEnable, setIsprintEnable] = useState(false);
  const [isSaveEnable, setIsSaveEnable] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);
  const [isDataUpdate, setIsDataUpdate] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [openConfirmExit, setOpenConfirmExit] = useState(false);
  const disable = selectedRowData.actual_start_date === null;

  const {
    updateImvChecklistSuccess,
    updateImvChecklistDataFn,
    updateImvChecklistIsError,
    createImvChecklistSuccess,
    createImvChecklistDataFn,
    createImvChecklistIsError,
    publishImvChecklistDataFn,
    publishImvChecklistLoading,
    publishImvChecklistSuccess,
    publishImvChecklistError
  } = useIMVCheckListPage();

  const { createImvReportDataFn, updateImvReportDataFn } = useIMVReportPage();

  const [fileObjects, setFileObjects] = useState<QulificationFileData[]>([]);
  const [fileObjects2, setFileObjects2] = useState<QulificationFileData[]>([]);
  const [fileObjects3, setFileObjects3] = useState<QulificationFileData[]>([]);
  const [fileObjects4, setFileObjects4] = useState<QulificationFileData[]>([]);
  const [fileObjects5, setFileObjects5] = useState<QulificationFileData[]>([]);
  const [fileObjects6, setFileObjects6] = useState<QulificationFileData[]>([]);
  const [isPublishEnable, setIsPublishEnable] = useState(false);

  const [section1, setSection1] = useState({
    stdy_imvcl_recruit: 'NA',
    stdy_imvcl_recruit_com: '',
    stdy_imvcl_rplan_rev: 'NA',
    stdy_imvcl_rplan_rev_comm: '',
    stdy_imvcl_rplan_actions: 'NA',
    stdy_imvcl_rplan_action_comm: '',
    stdy_imvcl_retention: 'NA',
    stdy_imvcl_retention_comm: '',
    stdy_imvcl_ret_actions: 'NA',
    stdy_imvcl_ret_action_comm: '',
    stdy_imvcl_new_pers: 'NA',
    stdy_imvcl_new_pers_comm: '',
    stdy_imvcl_training_todate: 'NA',
    stdy_imvcl_training_comment: '',
    stdy_imvcl_doa_completeness: 'NA',
    stdy_imvcl_doa_completeness_comment: '',
    stdy_imvcl_sa_ss_st_attachment1: ''
  });

  const [section2, setSection2] = useState({
    stdy_imvcl_irb_sub: 'NA',
    stdy_imvcl_irb_sub_comm: '',
    stdy_imvcl_irb_approval: 'NA',
    stdy_imvcl_irb_approval_comm: '',
    stdy_imvcl_irb_pending: 'NA',
    stdy_imvcl_irb_pending_comm: ''
  });

  const [section3, setSection3] = useState({
    stdy_imvcl_new_consent: 'NA',
    stdy_imvcl_new_consent_comm: '',
    stdy_imvcl_cons_regulation: 'NA',
    stdy_imvcl_cons_regulation_comm: '',
    stdy_imvcl_cons_doc: 'NA',
    stdy_imvcl_cons_doc_comm: '',
    stdy_imvcl_cons_attach2: ''
  });

  const [section4, setSection4] = useState({
    stdy_imvcl_source_doc: 'NA',
    stdy_imvcl_source_doc_comm: '',
    stdy_imvcl_source_rev: 'NA',
    stdy_imvcl_source_rev_comm: '',
    stdy_imvcl_sdv: 'NA',
    stdy_imvcl_sdv_comm: '',
    stdy_imvcl_end_pt: 'NA',
    stdy_imvcl_end_pt_comm: '',
    stdy_imvcl_data_int: 'NA',
    stdy_imvcl_data_int_comm: '',
    stdy_imvcl_action_log: 'NA',
    stdy_imvcl_action_log_comm: '',
    stdy_imvcl_pro_qna: 'NA',
    stdy_imvcl_pro_qna_comm: '',
    stdy_imvcl_mon_attachments: ''
  });

  const [section5, setSection5] = useState({
    stdy_imvcl_sae_fup: 'NA',
    stdy_imvcl_sae_fup_comm: '',
    stdy_imvcl_sae_report: 'NA',
    stdy_imvcl_sae_report_comm: '',
    stdy_imvcl_sae_sponsor: 'NA',
    stdy_imvcl_sae_sponsor_comm: '',
    stdy_imvcl_sae_irb: 'NA',
    stdy_imvcl_sae_irb_comm: '',
    stdy_imvcl_event_fup: 'NA',
    stdy_imvcl_event_fup_comm: '',
    stdy_imvcl_sreport_irb: 'NA',
    stdy_imvcl_sreport_irb_comm: '',
    stdy_imvcl_sreport_review: 'NA',
    stdy_imvcl_sreport_review_comm: ''
  });

  const [section6, setSection6] = useState({
    stdy_imvcl_csp_procedures: 'NA',
    stdy_imvcl_csp_procedure_comm: '',
    stdy_imvcl_csp_pd: 'NA',
    stdy_imvcl_csp_pd_comm: '',
    stdy_imvcl_csp_inelig: 'NA',
    stdy_imvcl_csp_inelig_comm: '',
    stdy_imvcl_csp_attachments: ''
  });

  const [section7, setSection7] = useState({
    stdy_imvcl_ip_acc: 'NA',
    stdy_imvcl_ip_acc_comm: '',
    stdy_imvcl_ip_req: 'NA',
    stdy_imvcl_ip_req_comm: '',
    stdy_imvcl_ip_excur: 'NA',
    stdy_imvcl_ip_excur_comm: '',
    stdy_imvcl_ip_issues: 'NA',
    stdy_imvcl_ip_issues_comm: '',
    stdy_imvcl_ip_ship_rec: 'NA',
    stdy_imvcl_ip_ship_rec_comm: '',
    stdy_imvcl_ip_suff: 'NA',
    stdy_imvcl_ip_suff_comm: '',
    stdy_imvcl_ip_unblind: 'NA',
    stdy_imvcl_ip_unblind_comm: '',
    stdy_imvcl_ip_attachments: ''
  });

  const [section8, setSection8] = useState({
    stdy_imvcl_supply: 'NA',
    stdy_imvcl_supply_comm: ''
  });

  const [section9, setSection9] = useState({
    stdy_imvcl_bio_collect: 'NA',
    stdy_imvcl_bio_collect_comm: '',
    stdy_imvcl_bio_handling: 'NA',
    stdy_imvcl_bio_handling_comm: ''
  });

  const [section10, setSection10] = useState({
    stdy_imvcl_llab_cert: 'NA',
    stdy_imvcl_llab_cert_comm: '',
    stdy_imvcl_calibrate: 'NA',
    stdy_imvcl_calibrate_comm: '',
    stdy_imvcl_llab_range: 'NA',
    stdy_imvcl_llab_range_comm: ''
  });

  const [section11, setSection11] = useState({
    stdy_imvcl_pid_enrol: 'NA',
    stdy_imvcl_pid_enrol_comm: '',
    stdy_imvcl_pid_study_up: 'NA',
    stdy_imvcl_pid_study_up_comm: '',
    stdy_imvcl_pid_staff: 'NA',
    stdy_imvcl_pid_staff_comm: '',
    stdy_imvcl_pid_oversight: 'NA',
    stdy_imvcl_pid_oversight_comm: '',
    stdy_imvcl_pid_issues: 'NA',
    stdy_imvcl_pid_issues_comm: '',
    stdy_imvcl_pid_sproc: 'NA',
    stdy_imvcl_pid_sproc_comm: '',
    stdy_imvcl_pid_sae: 'NA',
    stdy_imvcl_pid_sae_comm: '',
    stdy_imvcl_pid_pd: 'NA',
    stdy_imvcl_pid_pd_comm: '',
    stdy_imvcl_pid_sub_concern: 'NA',
    stdy_imvcl_pid_sub_concern_comm: '',
    stdy_imvcl_pid_add: 'NA',
    stdy_imvcl_pid_add_comm: ''
  });

  const [sivRepSection1, setSivRepSection1] = useState({
    stdy_imvrp_recruit: null,
    stdy_imvrp_recruit_com: null,
    stdy_imvrp_rplan_rev: null,
    stdy_imvrp_rplan_rev_comm: null,
    stdy_imvrp_rplan_actions: null,
    stdy_imvrp_rplan_action_comm: null,
    stdy_imvrp_retention: null,
    stdy_imvrp_retention_comm: null,
    stdy_imvrp_ret_actions: null,
    stdy_imvrp_ret_action_comm: null,
    stdy_imvrp_new_pers: null,
    stdy_imvrp_new_pers_comm: null,
    stdy_imvrp_training_todate: null,
    stdy_imvrp_training_comment: null,
    stdy_imvrp_doa_completeness: null,
    stdy_imvrp_doa_completeness_comment: null,
    stdy_imvrp_sa_ss_st_attachment1: null
  });

  const [sivRepSection2, setSivRepSection2] = useState({
    stdy_imvrp_irb_sub: null,
    stdy_imvrp_irb_sub_comm: null,
    stdy_imvrp_irb_approval: null,
    stdy_imvrp_irb_approval_comm: null,
    stdy_imvrp_irb_pending: null,
    stdy_imvrp_irb_pending_comm: null
  });

  const [sivRepSection3, setSivRepSection3] = useState({
    stdy_imvrp_new_consent: null,
    stdy_imvrp_new_consent_comm: null,
    stdy_imvrp_cons_regulation: null,
    stdy_imvrp_cons_regulation_comm: null,
    stdy_imvrp_cons_doc: null,
    stdy_imvrp_cons_doc_comm: null,
    stdy_imvrp_cons_attach2: null
  });

  const [sivRepSection4, setSivRepSection4] = useState({
    stdy_imvrp_source_doc: null,
    stdy_imvrp_source_doc_comm: null,
    stdy_imvrp_source_rev: null,
    stdy_imvrp_source_rev_comm: null,
    stdy_imvrp_sdv: null,
    stdy_imvrp_sdv_comm: null,
    stdy_imvrp_end_pt: null,
    stdy_imvrp_end_pt_comm: null,
    stdy_imvrp_data_int: null,
    stdy_imvrp_data_int_comm: null,
    stdy_imvrp_action_log: null,
    stdy_imvrp_action_log_comm: null,
    stdy_imvrp_pro_qna: null,
    stdy_imvrp_pro_qna_comm: null,
    stdy_imvrp_mon_attachments: null
  });

  const [sivRepSection5, setSivRepSection5] = useState({
    stdy_imvrp_sae_fup: null,
    stdy_imvrp_sae_fup_comm: null,
    stdy_imvrp_sae_report: null,
    stdy_imvrp_sae_report_comm: null,
    stdy_imvrp_sae_sponsor: null,
    stdy_imvrp_sae_sponsor_comm: null,
    stdy_imvrp_sae_irb: null,
    stdy_imvrp_sae_irb_comm: null,
    stdy_imvrp_event_fup: null,
    stdy_imvrp_event_fup_comm: null,
    stdy_imvrp_sreport_irb: null,
    stdy_imvrp_sreport_irb_comm: null,
    stdy_imvrp_sreport_review: null,
    stdy_imvrp_sreport_review_comm: null
  });

  const [sivRepSection6, setSivRepSection6] = useState({
    stdy_imvrp_csp_procedures: null,
    stdy_imvrp_csp_procedure_comm: null,
    stdy_imvrp_csp_pd: null,
    stdy_imvrp_csp_pd_comm: null,
    stdy_imvrp_csp_inelig: null,
    stdy_imvrp_csp_inelig_comm: null,
    stdy_imvrp_csp_attachments: null
  });

  const [sivRepSection7, setSivRepSection7] = useState({
    stdy_imvrp_ip_acc: null,
    stdy_imvrp_ip_acc_comm: null,
    stdy_imvrp_ip_req: null,
    stdy_imvrp_ip_req_comm: null,
    stdy_imvrp_ip_excur: null,
    stdy_imvrp_ip_excur_comm: null,
    stdy_imvrp_ip_issues: null,
    stdy_imvrp_ip_issues_comm: null,
    stdy_imvrp_ip_ship_rec: null,
    stdy_imvrp_ip_ship_rec_comm: null,
    stdy_imvrp_ip_suff: null,
    stdy_imvrp_ip_suff_comm: null,
    stdy_imvrp_ip_unblind: null,
    stdy_imvrp_ip_unblind_comm: null,
    stdy_imvrp_ip_attachments: null
  });

  const [sivRepSection8, setSivRepSection8] = useState({
    stdy_imvrp_supply: null,
    stdy_imvrp_supply_comm: null
  });

  const [sivRepSection9, setSivRepSection9] = useState({
    stdy_imvrp_bio_collect: null,
    stdy_imvrp_bio_collect_comm: null,
    stdy_imvrp_bio_handling: null,
    stdy_imvrp_bio_handling_comm: null
  });

  const [sivRepSection10, setSivRepSection10] = useState({
    stdy_imvrp_llab_cert: null,
    stdy_imvrp_llab_cert_comm: null,
    stdy_imvrp_calibrate: null,
    stdy_imvrp_calibrate_comm: null,
    stdy_imvrp_llab_range: null,
    stdy_imvrp_llab_range_comm: null
  });

  const [sivRepSection11, setSivRepSection11] = useState({
    stdy_imvrp_pid_enrol: null,
    stdy_imvrp_pid_enrol_comm: null,
    stdy_imvrp_pid_study_up: null,
    stdy_imvrp_pid_study_up_comm: null,
    stdy_imvrp_pid_staff: null,
    stdy_imvrp_pid_staff_comm: null,
    stdy_imvrp_pid_oversight: null,
    stdy_imvrp_pid_oversight_comm: null,
    stdy_imvrp_pid_issues: null,
    stdy_imvrp_pid_issues_comm: null,
    stdy_imvrp_pid_sproc: null,
    stdy_imvrp_pid_sproc_comm: null,
    stdy_imvrp_pid_sae: null,
    stdy_imvrp_pid_sae_comm: null,
    stdy_imvrp_pid_pd: null,
    stdy_imvrp_pid_pd_comm: null,
    stdy_imvrp_pid_sub_concern: null,
    stdy_imvrp_pid_sub_concern_comm: null,
    stdy_imvrp_pid_add: null,
    stdy_imvrp_pid_add_comm: null
  });

  const handleCheck = (e: any, Section?: string) => {
    const data = e?.target?.value;
    setIsChanged(true);
    setImvChecklistPageData({ ...imvChecklistPageData, [e.target.name]: data });
    if (Section === 'section1') {
      if (e.target.name in section1) {
        setSection1({
          ...section1,
          [e.target.name]: e.target.value
        });
      }
    }

    if (Section === 'section2') {
      if (e.target.name in section2) {
        setSection2({
          ...section2,
          [e.target.name]: e.target.value
        });
      }
    }

    if (Section === 'section3') {
      if (e.target.name in section3) {
        setSection3({
          ...section3,
          [e.target.name]: e.target.value
        });
      }
    }

    if (Section === 'section4') {
      if (e.target.name in section4) {
        setSection4({
          ...section4,
          [e.target.name]: e.target.value
        });
      }
    }

    if (Section === 'section5') {
      if (e.target.name in section5) {
        setSection5({
          ...section5,
          [e.target.name]: e.target.value
        });
      }
    }

    if (Section === 'section6') {
      if (e.target.name in section6) {
        setSection6({
          ...section6,
          [e.target.name]: e.target.value
        });
      }
    }

    if (Section === 'section7') {
      if (e.target.name in section7) {
        setSection7({
          ...section7,
          [e.target.name]: e.target.value
        });
      }
    }
    if (Section === 'section8') {
      if (e.target.name in section8) {
        setSection8({
          ...section8,
          [e.target.name]: e.target.value
        });
      }
    }
    if (Section === 'section9') {
      if (e.target.name in section9) {
        setSection9({
          ...section9,
          [e.target.name]: e.target.value
        });
      }
    }
    if (Section === 'section10') {
      if (e.target.name in section10) {
        setSection10({
          ...section10,
          [e.target.name]: e.target.value
        });
      }
    }
    if (Section === 'section11') {
      if (e.target.name in section11) {
        setSection11({
          ...section11,
          [e.target.name]: e.target.value
        });
      }
    }
    setConfirmExitValue(dispatch, true);
    setIsDataUpdate(true);
    setIsSaveEnable(true);
    setIsPublishEnable(false);
  };

  const handleComment = (e: any) => {
    const data = e.target.value;
    setImvChecklistPageData({ ...imvChecklistPageData, [e.target.name]: data });
    if (e.target.name in section1) {
      setSection1({
        ...section1,
        [e.target.name]: e.target.value
      });
    }

    setConfirmExitValue(dispatch, true);
  };

  const {
    data: imvCheckListData,
    error: imvCheckListDataError,
    isError: imvCheckListDataIsError,
    refetch: getImvChecklistData
  } = useGetimvChecklistDataQuery({
    site_id: selectedSite,
    study_id: studyId,
    country: selectedCountry,
    application: process.env.REACT_APP_NAME,
    monitoring_visit_id: selectedRowData.id
  });

  const handleNextbtn = (_: any) => {
    const popupShowed = localStorage.getItem('popupShowed');
    if (popupShowed == 'true' && confirmexitpopupval.confirmexitpopupval == true) {
      setConfirmExitPopupVal(dispatch, false);
      setConfirmExitPopupVal(dispatch, true);
    }
    setTabVal(tabVal + 1);
    dispatch(setShowIMVchecklistCMPArr('IMVChecklistTable'));
  };
  const handleToogleAccordion = () => {
    setExpanded(!expanded);
    setExpanded2(false);
  };
  const handleToogleAccordion2 = () => {
    setExpanded2(!expanded2);
    setExpanded(false);
  };

  const handleToogleAccordion3 = () => {
    setExpanded3(!expanded3);
    setExpanded2(false);
    setExpanded(false);
  };
  const handleToogleAccordion4 = () => {
    setExpanded4(!expanded4);
    setExpanded2(false);
    setExpanded3(false);
    setExpanded(false);
  };
  const handleToogleAccordion5 = () => {
    setExpanded5(!expanded5);
    setExpanded2(false);
    setExpanded3(false);
    setExpanded4(false);
    setExpanded(false);
  };
  const handleToogleAccordion6 = () => {
    setExpanded6(!expanded6);
    setExpanded2(false);
    setExpanded3(false);
    setExpanded4(false);
    setExpanded5(false);
    setExpanded(false);
  };
  const handleToogleAccordion7 = () => {
    setExpanded7(!expanded7);
    setExpanded2(false);
    setExpanded3(false);
    setExpanded4(false);
    setExpanded5(false);
    setExpanded6(false);
    setExpanded(false);
  };
  const handleToogleAccordion8 = () => {
    setExpanded8(!expanded8);
    setExpanded2(false);
    setExpanded3(false);
    setExpanded4(false);
    setExpanded5(false);
    setExpanded6(false);
    setExpanded7(false);
    setExpanded(false);
  };
  const handleToogleAccordion9 = () => {
    setExpanded9(!expanded9);
    setExpanded2(false);
    setExpanded3(false);
    setExpanded4(false);
    setExpanded5(false);
    setExpanded6(false);
    setExpanded7(false);
    setExpanded8(false);
    setExpanded(false);
  };
  const handleToogleAccordion10 = () => {
    setExpanded10(!expanded10);
    setExpanded2(false);
    setExpanded3(false);
    setExpanded4(false);
    setExpanded5(false);
    setExpanded6(false);
    setExpanded7(false);
    setExpanded8(false);
    setExpanded9(false);
    setExpanded(false);
  };
  const handleToogleAccordion11 = () => {
    setExpanded11(!expanded11);
    setExpanded2(false);
    setExpanded3(false);
    setExpanded4(false);
    setExpanded5(false);
    setExpanded6(false);
    setExpanded7(false);
    setExpanded8(false);
    setExpanded9(false);
    setExpanded(false);
    setExpanded10(false);
  };
  useEffect(() => {
    if (imvCheckListData) {
      setImvChecklistPageData(imvCheckListData);
      setSection1(imvCheckListData.stdy_imvcl_section1);
      setSection2(imvCheckListData.stdy_imvcl_section2);
      setSection3(imvCheckListData.stdy_imvcl_section3);
      setSection4(imvCheckListData.stdy_imvcl_section4);
      setSection5(imvCheckListData.stdy_imvcl_section5);
      setSection6(imvCheckListData.stdy_imvcl_section6);
      setSection7(imvCheckListData.stdy_imvcl_section7);
      setSection8(imvCheckListData.stdy_imvcl_section8);
      setSection9(imvCheckListData.stdy_imvcl_section9);
      setSection10(imvCheckListData.stdy_imvcl_section10);
      setSection11(imvCheckListData.stdy_imvcl_section11);
      setIsupdate(true);
      setIsprintEnable(true);
      if (imvCheckListData?.is_published && imvCheckListData?.is_published !== null) {
        setIsPublishEnable(true);
      } else {
        setIsPublishEnable(true);
      }
    }
  }, [imvCheckListData]);

  useEffect(() => {
    getImvReportData();
    return () => {
      dispatch(setShowIMVchecklistCMPArr('IMVChecklistTable'));
    };
  }, []);

  const postData = async (_: any) => {
    if (isDataUpdate) {
      const creqObj = {
        imv_checklist: {
          stdy_imvcl_section1: { ...section1 },
          stdy_imvcl_section2: { ...section2 },
          stdy_imvcl_section3: { ...section3 },
          stdy_imvcl_section4: { ...section4 },
          stdy_imvcl_section5: { ...section5 },
          stdy_imvcl_section6: { ...section6 },
          stdy_imvcl_section7: { ...section7 },
          stdy_imvcl_section8: { ...section8 },
          stdy_imvcl_section9: { ...section9 },
          stdy_imvcl_section10: { ...section10 },
          stdy_imvcl_section11: { ...section11 }
        },
        monitoring_visit_id: selectedRowData.id,
        created_by: user
      };
      const ureqObj = {
        imv_checklist: {
          stdy_imvcl_section1: { ...section1 },
          stdy_imvcl_section2: { ...section2 },
          stdy_imvcl_section3: { ...section3 },
          stdy_imvcl_section4: { ...section4 },
          stdy_imvcl_section5: { ...section5 },
          stdy_imvcl_section6: { ...section6 },
          stdy_imvcl_section7: { ...section7 },
          stdy_imvcl_section8: { ...section8 },
          stdy_imvcl_section9: { ...section9 },
          stdy_imvcl_section10: { ...section10 },
          stdy_imvcl_section11: { ...section11 }
        },
        monitoring_visit_id: selectedRowData.id,
        updated_by: user
      };

      try {
        if (isUpdate) {
          await updateImvChecklistDataFn({
            site_id: selectedSite,
            study_id: studyId,
            data: ureqObj,
            country: selectedCountry,
            application: process.env.REACT_APP_NAME
          });
        } else {
          await createImvChecklistDataFn({
            site_id: selectedSite,
            study_id: studyId,
            data: creqObj,
            country: selectedCountry,
            application: process.env.REACT_APP_NAME
          });
        }
        setConfirmExitValue(dispatch, false);
        getImvChecklistData();
        setIsprintEnable(true);
      } catch (e) {
        dispatchApp(setMessage({ msgDetails: 'Error occurred while saving the data', severity: 'error' }));
      }
    } else {
      dispatch(
        setMessage({
          msgDetails: 'No data modified',
          severity: 'success'
        })
      );
    }
    setIsChanged(false);
    setIsSaveEnable(false);
  };

  useEffect(() => {
    if (publishImvChecklistSuccess) {
      if (isConfirm) {
        dispatchApp(
          setMessage({
            msgDetails: 'IMV Checklist successfully published to ETMF repository and Data copied to IMV Report',
            severity: 'success'
          })
        );
      } else {
        dispatchApp(
          setMessage({ msgDetails: 'IMV Checklist successfully published to ETMF repository', severity: 'success' })
        );
      }
    } else if (publishImvChecklistError) {
      dispatchApp(setMessage({ msgDetails: 'IMV Checklist publish is getting Error', severity: 'error' }));
    }
  }, [publishImvChecklistSuccess, publishImvChecklistError]);

  const isUpdatePublish = imvCheckListData?.imv_checklist_publish_version ? true : false;
  /* publish checklist data */
  const publishData = async (_: any) => {
    try {
      dispatch(showLoader());
      if (isUpdatePublish) {
        setConfirmNewVersion(true);
      } else {
        await publishToEtmf();
        autoCopyDataToSIVReport();
      }
    } catch (e) {
      dispatchApp(setMessage({ msgDetails: 'Error occurred while saving the data', severity: 'error' }));
      dispatch(hideLoader());
    }
    dispatch(hideLoader());
  };
  async function publishToEtmf() {
    if (!publishImvChecklistLoading) {
      let version = '';
      if (isUpdatePublish) {
        version = imvCheckListData?.imv_checklist_publish_version + 1;
      } else {
        version = '1';
      }

      await publishImvChecklistDataFn({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,

        publish_doc_version: parseFloat(version).toFixed(1),
        monitoring_visit_id: selectedRowData.id,
        update: isUpdatePublish,
        application: process.env.REACT_APP_NAME,
        is_published: true
      });
      setConfirmExitValue(dispatch, false);
      setIsSaveEnable(false);
      getImvChecklistData();
    }
  }
  const handleCreateNewFormClose = () => {
    setConfirmNewVersion(false);
    setIsConfirm(false);
    publishToEtmf();
  };
  const handleCreateNewFormConfirm = () => {
    setConfirmNewVersion(false);
    setIsConfirm(true);
    publishToEtmf();
    autoCopyDataToSIVReport();
  };
  const printImvCheckListForm = async () => {
    try {
      dispatch(showLoader());
      const options = {
        monitoring_visit_id: imvCheckListData?.monitoring_visit_id,
        template_name: 'imv_checklist',
        study_id: studyId,
        site_id: selectedSite,
        pathVariables: {
          country: selectedCountry,
          appName: archLevel === 'sponsor' ? process.env.REACT_APP_NAME : 'TSDA',
          time_zone_id: UI_TIME_ZONE
        }
      };
      let pdfOptions: any = {};
      if (imvCheckListData?.imv_checklist_publish_version) {
        pdfOptions = {
          ...options,
          pathVariables: {
            version: imvCheckListData.imv_checklist_publish_version.toFixed(1),
            ...options.pathVariables
          }
        };
      } else {
        pdfOptions = options;
      }
      const printViewerApiString = imvCheckListData?.imv_checklist_publish_version
        ? 'get_imvChecklist_pdf_file_version'
        : 'get_imvChecklist_pdf_file';
      printPdfWithViewer(printViewerApiString, pdfOptions, 'application/pdf');

      setTimeout(function () {
        dispatch(hideLoader());
      }, 1500);
    } catch (error: any) {
      dispatch(hideLoader());
      dispatch(setMessage({ msgDetails: 'Error while fetching pdf', severity: 'error' }));
    }
  };

  useEffect(() => {
    if (createImvChecklistIsError || updateImvChecklistIsError) {
      dispatchApp(setMessage({ msgDetails: 'Error', severity: 'error' }));
    }
  }, [createImvChecklistIsError, updateImvChecklistIsError]);

  useEffect(() => {
    if (createImvChecklistSuccess || updateImvChecklistSuccess) {
      dispatchApp(setMessage({ msgDetails: 'Data Updated', severity: 'success' }));
    }
  }, [createImvChecklistSuccess, updateImvChecklistSuccess]);

  useEffect(() => {
    if (imvCheckListDataIsError) {
      const err: any = imvCheckListDataError;
      if (err?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403 Restricted User permission',
            severity: 'error'
          })
        );
      }
    }
  }, [imvCheckListDataIsError]);

  const handelBack = () => {
    if (isChanged) {
      setOpenConfirmExit(true);
    } else {
      dispatch(setShowIMVchecklistCMPArr('IMVChecklistTable'));
    }
  };

  const [getImvReportDatafunc, { data: imvReportData }] = useLazyGetimvReportDataQuery();
  const getImvReportData = () => {
    getImvReportDatafunc({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: process.env.REACT_APP_NAME,
      monitoring_visit_id: selectedRowData.id
    });
  };

  useEffect(() => {
    if (imvReportData) {
      setCopiedPublishedData(true);
    }
  }, imvReportData);
  const autoCopyDataToSIVReport = async () => {
    const site = imvCheckListData?.stdy_imvcl_section1;
    const ecIRB = imvCheckListData?.stdy_imvcl_section2;
    const section3 = imvCheckListData?.stdy_imvcl_section3;
    const section4 = imvCheckListData?.stdy_imvcl_section4;
    const section5 = imvCheckListData?.stdy_imvcl_section5;
    const section6 = imvCheckListData?.stdy_imvcl_section6;
    const section7 = imvCheckListData?.stdy_imvcl_section7;
    const section8 = imvCheckListData?.stdy_imvcl_section8;
    const section9 = imvCheckListData?.stdy_imvcl_section9;
    const section10 = imvCheckListData?.stdy_imvcl_section10;
    const section11 = imvCheckListData?.stdy_imvcl_section11;
    setSivRepSection1({
      ...sivRepSection1,
      stdy_imvrp_recruit: site.stdy_imvcl_recruit,
      stdy_imvrp_recruit_com: site.stdy_imvcl_recruit_com,
      stdy_imvrp_rplan_rev: site.stdy_imvcl_rplan_rev,
      stdy_imvrp_rplan_rev_comm: site.stdy_imvcl_rplan_rev_comm,
      stdy_imvrp_rplan_actions: site.stdy_imvcl_rplan_actions,
      stdy_imvrp_rplan_action_comm: site.stdy_imvcl_rplan_action_comm,
      stdy_imvrp_retention: site.stdy_imvcl_retention,
      stdy_imvrp_retention_comm: site.stdy_imvcl_retention_comm,
      stdy_imvrp_ret_actions: site.stdy_imvcl_ret_actions,
      stdy_imvrp_ret_action_comm: site.stdy_imvcl_ret_action_comm,
      stdy_imvrp_new_pers: site.stdy_imvcl_new_pers,
      stdy_imvrp_new_pers_comm: site.stdy_imvcl_new_pers_comm,
      stdy_imvrp_training_todate: site.stdy_imvcl_training_todate,
      stdy_imvrp_training_comment: site.stdy_imvcl_training_comment,
      stdy_imvrp_doa_completeness: site.stdy_imvcl_doa_completeness,
      stdy_imvrp_doa_completeness_comment: site.stdy_imvcl_doa_completeness_comment,
      stdy_imvrp_sa_ss_st_attachment1: site.stdy_imvcl_sa_ss_st_attachment1
    });

    setSivRepSection2({
      ...sivRepSection2,
      stdy_imvrp_irb_sub: ecIRB.stdy_imvcl_irb_sub,
      stdy_imvrp_irb_sub_comm: ecIRB.stdy_imvcl_irb_sub_comm,
      stdy_imvrp_irb_approval: ecIRB.stdy_imvcl_irb_approval,
      stdy_imvrp_irb_approval_comm: ecIRB.stdy_imvcl_irb_approval_comm,
      stdy_imvrp_irb_pending: ecIRB.stdy_imvcl_irb_pending,
      stdy_imvrp_irb_pending_comm: ecIRB.stdy_imvcl_irb_pending_comm
    });

    setSivRepSection3({
      ...sivRepSection3,
      stdy_imvrp_new_consent: section3.stdy_imvcl_new_consent,
      stdy_imvrp_new_consent_comm: section3.stdy_imvcl_new_consent_comm,
      stdy_imvrp_cons_regulation: section3.stdy_imvcl_cons_regulation,
      stdy_imvrp_cons_regulation_comm: section3.stdy_imvcl_cons_regulation_comm,
      stdy_imvrp_cons_doc: section3.stdy_imvcl_cons_doc,
      stdy_imvrp_cons_doc_comm: section3.stdy_imvcl_cons_doc_comm,
      stdy_imvrp_cons_attach2: section3.stdy_imvcl_cons_attach2
    });

    setSivRepSection4({
      ...sivRepSection4,
      stdy_imvrp_source_doc: section4.stdy_imvcl_source_doc,
      stdy_imvrp_source_doc_comm: section4.stdy_imvcl_source_doc_comm,
      stdy_imvrp_source_rev: section4.stdy_imvcl_source_rev,
      stdy_imvrp_source_rev_comm: section4.stdy_imvcl_source_rev_comm,
      stdy_imvrp_sdv: section4.stdy_imvcl_sdv,
      stdy_imvrp_sdv_comm: section4.stdy_imvcl_sdv_comm,
      stdy_imvrp_end_pt: section4.stdy_imvcl_end_pt,
      stdy_imvrp_end_pt_comm: section4.stdy_imvcl_end_pt_comm,
      stdy_imvrp_data_int: section4.stdy_imvcl_data_int,
      stdy_imvrp_data_int_comm: section4.stdy_imvcl_data_int_comm,
      stdy_imvrp_action_log: section4.stdy_imvcl_action_log,
      stdy_imvrp_action_log_comm: section4.stdy_imvcl_action_log_comm,
      stdy_imvrp_pro_qna: section4.stdy_imvcl_pro_qna,
      stdy_imvrp_pro_qna_comm: section4.stdy_imvcl_pro_qna_comm,
      stdy_imvrp_mon_attachments: section4.stdy_imvcl_mon_attachments
    });

    setSivRepSection5({
      ...sivRepSection5,
      stdy_imvrp_sae_fup: section5.stdy_imvcl_sae_fup,
      stdy_imvrp_sae_fup_comm: section5.stdy_imvcl_sae_fup_comm,
      stdy_imvrp_sae_report: section5.stdy_imvcl_sae_report,
      stdy_imvrp_sae_report_comm: section5.stdy_imvcl_sae_report_comm,
      stdy_imvrp_sae_sponsor: section5.stdy_imvcl_sae_sponsor,
      stdy_imvrp_sae_sponsor_comm: section5.stdy_imvcl_sae_sponsor_comm,
      stdy_imvrp_sae_irb: section5.stdy_imvcl_sae_irb,
      stdy_imvrp_sae_irb_comm: section5.stdy_imvcl_sae_irb_comm,
      stdy_imvrp_event_fup: section5.stdy_imvcl_event_fup,
      stdy_imvrp_event_fup_comm: section5.stdy_imvcl_event_fup_comm,
      stdy_imvrp_sreport_irb: section5.stdy_imvcl_sreport_irb,
      stdy_imvrp_sreport_irb_comm: section5.stdy_imvcl_sreport_irb_comm,
      stdy_imvrp_sreport_review: section5.stdy_imvcl_sreport_review,
      stdy_imvrp_sreport_review_comm: section5.stdy_imvcl_sreport_review_comm
    });

    setSivRepSection6({
      ...sivRepSection6,
      stdy_imvrp_csp_procedures: section6.stdy_imvcl_csp_procedures,
      stdy_imvrp_csp_procedure_comm: section6.stdy_imvcl_csp_procedure_comm,
      stdy_imvrp_csp_pd: section6.stdy_imvcl_csp_pd,
      stdy_imvrp_csp_pd_comm: section6.stdy_imvcl_csp_pd_comm,
      stdy_imvrp_csp_inelig: section6.stdy_imvcl_csp_inelig,
      stdy_imvrp_csp_inelig_comm: section6.stdy_imvcl_csp_inelig_comm,
      stdy_imvrp_csp_attachments: section6.stdy_imvcl_csp_attachments
    });

    setSivRepSection7({
      ...sivRepSection7,
      stdy_imvrp_ip_acc: section7.stdy_imvcl_ip_acc,
      stdy_imvrp_ip_acc_comm: section7.stdy_imvcl_ip_acc_comm,
      stdy_imvrp_ip_req: section7.stdy_imvcl_ip_req,
      stdy_imvrp_ip_req_comm: section7.stdy_imvcl_ip_req_comm,
      stdy_imvrp_ip_excur: section7.stdy_imvcl_ip_excur,
      stdy_imvrp_ip_excur_comm: section7.stdy_imvcl_ip_excur_comm,
      stdy_imvrp_ip_issues: section7.stdy_imvcl_ip_issues,
      stdy_imvrp_ip_issues_comm: section7.stdy_imvcl_ip_issues_comm,
      stdy_imvrp_ip_ship_rec: section7.stdy_imvcl_ip_ship_rec,
      stdy_imvrp_ip_ship_rec_comm: section7.stdy_imvcl_ip_ship_rec_comm,
      stdy_imvrp_ip_suff: section7.stdy_imvcl_ip_suff,
      stdy_imvrp_ip_suff_comm: section7.stdy_imvcl_ip_suff_comm,
      stdy_imvrp_ip_unblind: section7.stdy_imvcl_ip_unblind,
      stdy_imvrp_ip_unblind_comm: section7.stdy_imvcl_ip_unblind_comm,
      stdy_imvrp_ip_attachments: section7.stdy_imvcl_ip_attachments
    });

    setSivRepSection8({
      ...sivRepSection8,
      stdy_imvrp_supply: section8.stdy_imvcl_supply,
      stdy_imvrp_supply_comm: section8.stdy_imvcl_supply_comm
    });

    setSivRepSection9({
      ...sivRepSection9,
      stdy_imvrp_bio_collect: section9.stdy_imvcl_bio_collect,
      stdy_imvrp_bio_collect_comm: section9.stdy_imvcl_bio_collect_comm,
      stdy_imvrp_bio_handling: section9.stdy_imvcl_bio_handling,
      stdy_imvrp_bio_handling_comm: section9.stdy_imvcl_bio_handling_comm
    });

    setSivRepSection10({
      ...sivRepSection10,
      stdy_imvrp_llab_cert: section10.stdy_imvcl_llab_cert,
      stdy_imvrp_llab_cert_comm: section10.stdy_imvcl_llab_cert_comm,
      stdy_imvrp_calibrate: section10.stdy_imvcl_calibrate,
      stdy_imvrp_calibrate_comm: section10.stdy_imvcl_calibrate_comm,
      stdy_imvrp_llab_range: section10.stdy_imvcl_llab_range,
      stdy_imvrp_llab_range_comm: section10.stdy_imvcl_llab_range_comm
    });

    setSivRepSection11({
      ...sivRepSection11,
      stdy_imvrp_pid_enrol: section11.stdy_imvcl_pid_enrol,
      stdy_imvrp_pid_enrol_comm: section11.stdy_imvcl_pid_enrol_comm,
      stdy_imvrp_pid_study_up: section11.stdy_imvcl_pid_study_up,
      stdy_imvrp_pid_study_up_comm: section11.stdy_imvcl_pid_study_up_comm,
      stdy_imvrp_pid_staff: section11.stdy_imvcl_pid_staff,
      stdy_imvrp_pid_staff_comm: section11.stdy_imvcl_pid_staff_comm,
      stdy_imvrp_pid_oversight: section11.stdy_imvcl_pid_oversight,
      stdy_imvrp_pid_oversight_comm: section11.stdy_imvcl_pid_oversight_comm,
      stdy_imvrp_pid_issues: section11.stdy_imvcl_pid_issues,
      stdy_imvrp_pid_issues_comm: section11.stdy_imvcl_pid_issues_comm,
      stdy_imvrp_pid_sproc: section11.stdy_imvcl_pid_sproc,
      stdy_imvrp_pid_sproc_comm: section11.stdy_imvcl_pid_sproc_comm,
      stdy_imvrp_pid_sae: section11.stdy_imvcl_pid_sae,
      stdy_imvrp_pid_sae_comm: section11.stdy_imvcl_pid_sae_comm,
      stdy_imvrp_pid_pd: section11.stdy_imvcl_pid_pd,
      stdy_imvrp_pid_pd_comm: section11.stdy_imvcl_pid_pd_comm,
      stdy_imvrp_pid_sub_concern: section11.stdy_imvcl_pid_sub_concern,
      stdy_imvrp_pid_sub_concern_comm: section11.stdy_imvcl_pid_sub_concern_comm,
      stdy_imvrp_pid_add: section11.stdy_imvcl_pid_add,
      stdy_imvrp_pid_add_comm: section11.stdy_imvcl_pid_add_comm
    });

    setIsAutoCopy(true);
  };

  useEffect(() => {
    if (isAutoCopy) {
      if (copiedPublishedData) {
        const payLoad = {
          imv_report: {
            site_adequacy: { ...sivRepSection1 },
            ec_irb: { ...sivRepSection2 },
            informed_consent: { ...sivRepSection3 },
            monitoring_activities: { ...sivRepSection4 },
            sae_safety_reporting: { ...sivRepSection5 },
            protocol_compliance: { ...sivRepSection6 },
            investigational_medicinal_product: { ...sivRepSection7 },
            supplies_including_ancillaries: { ...sivRepSection8 },
            biological_sampling: { ...sivRepSection9 },
            local_lab_only: { ...sivRepSection10 },
            discussion_with_pi: { ...sivRepSection11 }
          },
          monitoring_visit_id: selectedRowData.id,
          is_submit: false,
          updated_by: user
        };
        updateImvReportDataFn({
          site_id: selectedSite,
          study_id: studyId,
          data: payLoad,
          country: selectedCountry,

          application: process.env.REACT_APP_NAME
        });
      } else {
        const crPayLoad = {
          imv_report: {
            site_adequacy: { ...sivRepSection1 },
            ec_irb: { ...sivRepSection2 },
            informed_consent: { ...sivRepSection3 },
            monitoring_activities: { ...sivRepSection4 },
            sae_safety_reporting: { ...sivRepSection5 },
            protocol_compliance: { ...sivRepSection6 },
            investigational_medicinal_product: { ...sivRepSection7 },
            supplies_including_ancillaries: { ...sivRepSection8 },
            biological_sampling: { ...sivRepSection9 },
            local_lab_only: { ...sivRepSection10 },
            discussion_with_pi: { ...sivRepSection11 }
          },
          monitoring_visit_id: selectedRowData.id,
          is_submit: false,
          created_by: user
        };
        createImvReportDataFn({
          site_id: selectedSite,
          study_id: studyId,
          data: crPayLoad,
          country: selectedCountry,

          application: process.env.REACT_APP_NAME
        });
      }
    }
  }, [isAutoCopy]);
  return (
    <>
      <Box className="mainBackBtnWrap" sx={{ ml: 0.5 }}>
        <Button
          onClick={handelBack}
          key={staticData.imvChecklist.back_button}
          startIcon={<DynamicIcon name={staticData.imvChecklist.icon} />}
        >
          {staticData.imvChecklist.back_button_name}
        </Button>
      </Box>
      <div className="pi-accordion" style={{ marginBottom: 0 }}>
        {isLoading && <ProgressBar />}
        <Box sx={{ position: 'sticky', top: 0, zIndex: 5, width: '100%' }}>
          <Grid container spacing={2} alignItems="center" className="titleGrid">
            <Grid item xs>
              <Stack direction="row" spacing={4} alignItems="center">
                <Typography variant="h6" component="h6" sx={{ pl: 2 }}>
                  {selectedRowData.visit_name}
                </Typography>
              </Stack>
            </Grid>
            <Grid item sx={{ textAlign: 'right', display: 'flex' }}>
              <Stack direction="row" spacing={1}>
                <Button
                  onClick={postData}
                  disabled={!checkPermission('update_imvchecklist') || !isSaveEnable || disable}
                >
                  SAVE
                </Button>
                <Button onClick={printImvCheckListForm} disabled={!isPrintEnable}>
                  <IconButton>
                    <LocalPrintshopIcon />
                  </IconButton>
                </Button>
              </Stack>
            </Grid>
          </Grid>

          <Grid container rowSpacing={1} columnSpacing={{ md: 3 }} sx={{ typography: 'body1', mb: 2, pl: 2 }}>
            <Grid item md={12}>
              <Typography>
                <strong>Company Confidential </strong>
                <span className="results"> </span>
              </Typography>
            </Grid>
            <Grid item md={12}>
              <Typography>
                <strong>Document No: </strong>
                <span className="results">xxxx </span> <span>Version: </span>
                <span className="results">
                  {selectedRowData.major_version > '0.0' ? selectedRowData.major_version : '1.0'}{' '}
                </span>
              </Typography>
            </Grid>

            <Grid item md={12}>
              <Typography>
                <strong>Effective Date: </strong>
                <span className="results">MM/DD/YY</span>
              </Typography>
            </Grid>

            <Grid item md={12}>
              <Typography>
                <strong>Visit Type:</strong>
                <span className="results"> {selectedRowData.visit_type} </span>
              </Typography>
            </Grid>

            <Grid item md={12}>
              <Typography>
                <strong>Date of Visit: </strong>
                <span className="results">
                  {getPreferredDateTimeInLocal(selectedRowData.start_date).split(' ')[0]}{' '}
                </span>
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <Accordion expanded={expanded} onChange={handleToogleAccordion}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>Site Adequacy, Site Status, Site Training</Typography>
          </AccordionSummary>
          <Site
            imvChecklistPageData={imvChecklistPageData}
            setImvChecklistPageData={setImvChecklistPageData}
            handleCheck={handleCheck}
            isDisable={isDisable}
            validationObj={section1}
            handleComment={handleComment}
            fileObjects={fileObjects}
            setFileObjects={setFileObjects}
            setSection1={setSection1}
            section1={section1}
            setIsChanged={setIsChanged}
            setIsDataUpdate={setIsDataUpdate}
            disable={disable}
          />
        </Accordion>

        <Accordion expanded={expanded2} onChange={handleToogleAccordion2}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
            <Typography>EC/IRB</Typography>
          </AccordionSummary>
          <ECIRB
            imvChecklistPageData={imvChecklistPageData}
            setImvChecklistPageData={setImvChecklistPageData}
            handleCheck={handleCheck}
            isDisable={isDisable}
            validationObj={section2}
            handleComment={handleComment}
            setIsDataUpdate={setIsDataUpdate}
            disable={disable}
          />
        </Accordion>

        <Accordion expanded={expanded3} onChange={handleToogleAccordion3}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>Informed consent</Typography>
          </AccordionSummary>
          <InfomredConsentProcess
            imvChecklistPageData={imvChecklistPageData}
            setImvChecklistPageData={setImvChecklistPageData}
            handleCheck={handleCheck}
            isDisable={isDisable}
            validationObj={section3}
            handleComment={handleComment}
            fileObjects2={fileObjects2}
            setFileObjects2={setFileObjects2}
            setSection3={setSection3}
            section3={section3}
            setIsChanged={setIsChanged}
            setIsDataUpdate={setIsDataUpdate}
            disable={disable}
          />
        </Accordion>

        <Accordion expanded={expanded4} onChange={handleToogleAccordion4}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>Monitoring activities</Typography>
          </AccordionSummary>
          <MonitioringRequirments
            imvChecklistPageData={imvChecklistPageData}
            setImvChecklistPageData={setImvChecklistPageData}
            handleCheck={handleCheck}
            isDisable={isDisable}
            validationObj={section4}
            handleComment={handleComment}
            fileObjects3={fileObjects3}
            setFileObjects3={setFileObjects3}
            setSection4={setSection4}
            setIsChanged={setIsChanged}
            setIsDataUpdate={setIsDataUpdate}
            disable={disable}
          />
        </Accordion>

        <Accordion expanded={expanded6} onChange={handleToogleAccordion6}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>SAE/Safety reporting</Typography>
          </AccordionSummary>
          <SeriousAdverseEvents
            imvChecklistPageData={imvChecklistPageData}
            setImvChecklistPageData={setImvChecklistPageData}
            handleCheck={handleCheck}
            isDisable={isDisable}
            validationObj={section5}
            handleComment={handleComment}
            fileObjects4={fileObjects4}
            setFileObjects4={setFileObjects4}
            setSection5={setSection5}
            setIsChanged={setIsChanged}
            setIsDataUpdate={setIsDataUpdate}
            disable={disable}
          />
        </Accordion>

        <Accordion expanded={expanded5} onChange={handleToogleAccordion5}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>Protocol Compliance</Typography>
          </AccordionSummary>
          <ProtocolDeviations
            imvChecklistPageData={imvChecklistPageData}
            setImvChecklistPageData={setImvChecklistPageData}
            handleCheck={handleCheck}
            isDisable={isDisable}
            validationObj={section6}
            handleComment={handleComment}
            fileObjects5={fileObjects5}
            setFileObjects5={setFileObjects5}
            setSection6={setSection6}
            setIsChanged={setIsChanged}
            setIsDataUpdate={setIsDataUpdate}
            disable={disable}
          />
        </Accordion>

        <Accordion expanded={expanded7} onChange={handleToogleAccordion7}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>Investigational medicinal product</Typography>
          </AccordionSummary>
          <InvestigationalMedicine
            imvChecklistPageData={imvChecklistPageData}
            setImvChecklistPageData={setImvChecklistPageData}
            handleCheck={handleCheck}
            isDisable={isDisable}
            validationObj={section7}
            handleComment={handleComment}
            fileObjects6={fileObjects6}
            setFileObjects6={setFileObjects6}
            setSection7={setSection7}
            setIsChanged={setIsChanged}
            setIsDataUpdate={setIsDataUpdate}
            disable={disable}
          />
        </Accordion>

        <Accordion expanded={expanded8} onChange={handleToogleAccordion8}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>Supplies including ancillaries</Typography>
          </AccordionSummary>
          <Supplies
            imvChecklistPageData={imvChecklistPageData}
            setImvChecklistPageData={setImvChecklistPageData}
            handleCheck={handleCheck}
            isDisable={isDisable}
            validationObj={section8}
            handleComment={handleComment}
            fileObjects={fileObjects}
            setFileObjects={setFileObjects}
            setIsDataUpdate={setIsDataUpdate}
            disable={disable}
          />
        </Accordion>

        <Accordion expanded={expanded9} onChange={handleToogleAccordion9}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>Biological sampling</Typography>
          </AccordionSummary>
          <BiologicalSampling
            imvChecklistPageData={imvChecklistPageData}
            setImvChecklistPageData={setImvChecklistPageData}
            handleCheck={handleCheck}
            isDisable={isDisable}
            validationObj={section9}
            handleComment={handleComment}
            fileObjects={fileObjects}
            setFileObjects={setFileObjects}
            disable={disable}
          />
        </Accordion>

        <Accordion expanded={expanded10} onChange={handleToogleAccordion10}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>Local lab only</Typography>
          </AccordionSummary>
          <Lab
            imvChecklistPageData={imvChecklistPageData}
            setImvChecklistPageData={setImvChecklistPageData}
            handleCheck={handleCheck}
            isDisable={isDisable}
            validationObj={section10}
            handleComment={handleComment}
            fileObjects={fileObjects}
            setFileObjects={setFileObjects}
            disable={disable}
          />
        </Accordion>

        <Accordion expanded={expanded11} onChange={handleToogleAccordion11}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
            <Typography sx={{ width: '33%', flexShrink: 0 }}>Discussion with PI</Typography>
          </AccordionSummary>
          <Discussion
            imvChecklistPageData={imvChecklistPageData}
            setImvChecklistPageData={setImvChecklistPageData}
            handleCheck={handleCheck}
            isDisable={isDisable}
            validationObj={section11}
            handleComment={handleComment}
            fileObjects={fileObjects}
            setFileObjects={setFileObjects}
            disable={disable}
          />
        </Accordion>

        {currentTabinfo[0].NextButton && (
          <Grid container spacing={2} className="bottom-navigation">
            <Grid item md={12} display="flex" justifyContent="flex-end">
              <Stack spacing={2} direction="row">
                <Button
                  onClick={publishData}
                  variant="contained"
                  disabled={
                    !checkPermission('publish_imvchecklist') || !isPublishEnable || imvCheckListData?.is_published
                  }
                  style={{ textTransform: 'none' }}
                >
                  PUBLISH TO eTMF
                </Button>
                <Button onClick={handleNextbtn} variant="contained">
                  NEXT
                </Button>
              </Stack>
            </Grid>
          </Grid>
        )}

        <PopupComponent
          open={confirmNewVersion}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="confirm-modal"
        >
          <DialogTitle id="alert-dialog-title">{'Confirm Changes'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              The changes you made will be lost in IMV Report <br />
              Are you sure you want to continue?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleCreateNewFormConfirm()} className="grey-btn">
              Yes
            </Button>
            <Button onClick={() => handleCreateNewFormClose()} autoFocus>
              No
            </Button>
          </DialogActions>
        </PopupComponent>
        <PopupComponent
          open={openConfirmExit}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="confirm-modal"
          child
        >
          <DialogTitle id="alert-dialog-title">{'Confirm Exit'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">{unSavedWarning}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setOpenConfirmExit(false);
              }}
              className="grey-btn"
            >
              Close
            </Button>
            <Button
              onClick={() => {
                setOpenConfirmExit(false);
                dispatch(setShowIMVchecklistCMPArr('IMVChecklistTable'));
                setConfirmExitPopupVal(dispatch, false);
                setIsChanged(false);
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </PopupComponent>
      </div>
    </>
  );
};

export default IMVChecklistPage;
